<template>
    <div class="app-container mt-5">
        <div class="page-title mb-3">
            <router-link to="/configuration">
                <span class="breadcrumb-link">
                    <v-icon class="breadcrumb-link-icon">settings</v-icon> Configuration du compte
                </span>
            </router-link>
            <v-icon>keyboard_arrow_right</v-icon>
            <span class="breadcrumb-item">
                <v-icon class="breadcrumb-item-icon">web</v-icon> Mon espace Uska Pro
            </span>
        </div>

        <div class="row">
            <div class="col-3">
                <v-alert text class="mb-5">
                    Facilitez l’accès de vos socio-professionnels à leur espace pro Uska.
                    Créez et personnalisez un widget à intégrer sur votre site internet, puis ajoutez-le à l’emplacement de votre choix.
                </v-alert>
            </div>
            <div class="col">
                <v-card class="p-4">
                    <div class="d-flex mb-5">
                        <v-btn outlined class="custom-button-primary" @click="getUskaUrl"
                               :loading="loading" :disabled="loading">
                            <v-icon left>arrow_forward</v-icon> Accéder à votre espace Uska pour gérer votre territoire
                        </v-btn>
                    </div>
                </v-card>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import Confirm from "../../tools/Confirm"

export default {
    name: "UskaProConfig",
    data() {
        return {
            loading: false,
        }
    },
    methods: {
        getUskaUrl() {
            this.loading = true
            const newTab = window.open('', '_blank');

            const fail = () => {
                if (newTab) newTab.close();
            };

            this.$http.get('auth/pro-connexions/settings/' + this.user.id + '/uska/open').then(res => {
                if (res.body.success && res.body.data.url) {
                    newTab.location.href = res.body.data.url;
                } else {
                    fail();
                }
            }).catch(fail).finally(() => {
                this.loading = false;
            });
        },
    },
    computed: {
        ...mapState('account', ['user']),
    },
}
</script>